import {AnyAction, combineReducers} from "redux";
import {PAUSE_TIMER, RESET_TIMER, RESUME_TIMER, START_TIMER, STOP_TIMER, TICK_TIMER, TIMER_HAS_EXPIRED} from "../actions/action";
import {getEnergyOutput, getTargetEnergyOutput} from "./outputs/energyOutput";
import {createSelector} from "reselect";
import {getScreen, SCREENS} from "./screen";
import {getActivePopup} from "./popup";
import {getActiveModal} from "./modal";
import {isResultsPanelOpen} from "./results";
import {getYearData} from './year';
import {IYear} from '../../data/data';

//  define selectors

export const getTime = state => state.timer.time;
export const timerIsRunning = state => state.timer.running;
export const timerIsPaused = state => state.timer.paused;

export const getYearDuration = createSelector(

    [getYearData],

    (year_data: IYear) =>
    {
        return year_data['time'] || 60;
    }
);


/**
 * handle time
 * @param state
 * @param action
 * @return {boolean}
 */
function time(state: number = 0, action: AnyAction) : number
{
    switch (action.type)
    {
        case TICK_TIMER:
        {
            return state + 1;
        }

        case RESET_TIMER:
        {
            return 0;
        }

        default:

            return state;
    }
}


/**
 * is the timer running?
 * @param state
 * @param action
 * @return {boolean}
 */
function running(state: boolean = false, action: AnyAction) : boolean
{
    switch (action.type)
    {
        case START_TIMER:
        {
            return true;
        }

        case STOP_TIMER:
        {
            return false;
        }

        case TIMER_HAS_EXPIRED:
        {
            return false;
        }

        default:

            return state;
    }
}


/**
 * is the timer paused?
 * @param state
 * @param action
 * @return {boolean}
 */
function paused(state: boolean = false, action: AnyAction) : boolean
{
    switch (action.type)
    {
        case PAUSE_TIMER:
        {
            return true;
        }

        case RESUME_TIMER:
        case TIMER_HAS_EXPIRED:
        {
            return false;
        }

        default:

            return state;
    }
}


/**
 * test whether the game timer is running
 */
export const isTimerRunning = createSelector(

    [timerIsRunning, getScreen, getActivePopup, getActiveModal, isResultsPanelOpen],

    (running: boolean, screen_id: string, popup_id: string, modal_id: string, ui_is_open: string) : boolean =>
    {
        console.group('isTimerRunning');
        console.log(running);
        console.log(screen_id);
        console.log(popup_id);
        console.log(modal_id);
        console.log(ui_is_open);
        console.log('result: ', running && screen_id === SCREENS.GAME && ! popup_id && ! modal_id && ! ui_is_open);
        console.groupEnd();

        return running && screen_id === SCREENS.GAME && ! popup_id && ! modal_id && ! ui_is_open;
    }
);


export const timer = combineReducers({
    time,
    running,
    paused
});



// WEBPACK FOOTER //
// ./src/ts/store/reducers/timer.ts